module.exports = __webpack_public_path__ + "img/ultra_2_banner.fa89ec5d.jpg";